export type DataImportPayload = {
  file: File;
};

type DataImportStatus = "created" | "validating" | "validationSucceeded" | "validationFailed" | "failed";

export type DataImport = {
  dataImport: {
    createdBy: string;
    status: DataImportStatus;
    createdAt: string;
    updatedAt: string;
    fileName: string;
    validationFileName?: File;
    name: string;
  };
};

export const IsDataImportResponse = (response: unknown): response is DataImport =>
  typeof response === "object" && response !== null && "dataImport" in response;
